import {
	Component,
	OnInit
} from '@angular/core';
import {
	NgModel,
	FormGroup,
	FormBuilder,
	Validators,
	FormControl
} from '@angular/forms';
import {
	Router
} from '@angular/router';
import {
	EmailService, 
	IMessage
} from '../services/email.component';
@Component({
	selector: 'contact-us',
	styleUrls: ['../styles/contact-us.component.css'],
	templateUrl: '../views/contact-us.component.html',
	providers: [EmailService]
})

export class ContactUsComponent{
	form: FormGroup;
	message:IMessage = {
		first_name: "",
		last_name: "",
		email: "",
		phone: "",
		about_you: "",
		accounting_bookkeeping: false,
		tax: false,
		payroll_processing: false,
		consulting: false
	};

	constructor(private emailService:EmailService, 
							private formBuilder:FormBuilder,
							private router:Router)
	{

	}
	ngOnInit(){
		this.form = this.formBuilder.group({
			first_name: new FormControl(this.message.first_name, [Validators.required, Validators.minLength(2)]),
			last_name: new FormControl(this.message.last_name, [Validators.required, Validators.minLength(2)]),
			email: new FormControl(this.message.email, [Validators.required, Validators.email]),
			phone: new FormControl(this.message.phone, [Validators.minLength(10),Validators.pattern('(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}')]),
			about_you: new FormControl(null, [Validators.required, Validators.minLength(15)]),
			accounting_bookkeeping: new FormControl(false),
			tax: new FormControl(false),
			payroll_processing: new FormControl(false),
			consulting: new FormControl(false)
		});
	}
	isFieldValid(field: string){
		return !this.form.get(field).valid && this.form.get(field).touched;
	}
	displayFieldCss(field: string){
		return {
			'has-error': this.isFieldValid(field),
			'has-feedback': this.isFieldValid(field)
		};
	}
	validateField(field: string){
		return (field !== '' && field !== null);
	}
	sendMail(message: IMessage){
		for(var key in this.form.controls){
			message[key] = this.form.controls[key].value;
		}
		var we = this.validateField(message.first_name);
		var are = this.validateField(message.last_name);
		var okie = this.validateField(message.email);
		var dokie = this.validateField(message.about_you);

		if(!(we && are && okie && dokie)){
		  Object.keys(this.form.controls).forEach(key => {
		  	this.form.get(key).markAsDirty();
		    this.form.get(key).markAsTouched();
		    this.form.updateValueAndValidity();
		  });
			return;
		}
		this.emailService.sendEmail(message).subscribe(res => {
			this.router.navigateByUrl('/contact-complete');
			// console.log('ContactUsComponent Success', res)
		}, 
		error =>{
			this.router.navigateByUrl('/contact-error');
			// console.error('ContactUsComponent Error', error);
		})
	}
}


// WEBPACK FOOTER //
// D:/Projects/GitHub/gvrogers/src/app/components/contact-us.component.ts